var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17516",
    d: "M29.287 3.01a9.212 9.212 0 00-13.288-.336A9.119 9.119 0 009.519 0a9.275 9.275 0 00-6.81 3 10.441 10.441 0 000 14.031l10.95 11.943A3.161 3.161 0 0015.874 30h.127a3.158 3.158 0 002.159-.848c.062-.057.12-.116.179-.18l10.948-11.918a10.443 10.443 0 000-14.044",
    fill: "currentColor"
  })));
}
export default SvgHeartFilled;